<template>
  <div id="app" :class="currentView">
    <Notifications class="editor__notifications" />
    <div class="beta-info">
      <div class="beta-info__title">
        <span>BETA</span>
      </div>
      <div class="beta-info__version">
        <span>v0.9.0.0</span>
      </div>
    </div>
    <sidebar />
    <!--
    <router-view name="header" />
    -->
    <router-view class="content" />
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar';
import Notifications from '@/components/Notifications'
import urlUtils from "./utils/urls.js";
import api from "./api";
import {mapGetters, mapActions} from "vuex"

export default {
  name: "app",

  data() {
    return {
      currentRoute: null
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user']),
    
    currentView() {
      return `${this.currentRoute}-view-root`
    }
  },

  watch:{
    $route (to, from){
        this.currentRoute = to.name;
    }
},

  created() {
    var customerID = urlUtils.getParameterByName("customerID") || "default";
    console.log("app created. customerID: ", customerID);
    if (customerID) {
      this.fetchData(customerID)
    }

    if (this.isAuthenticated) {
      this.tryLoginUser()
      setInterval(() => {
        this.tryLoginUser()
      }, 3600000)
    }
  },
  components: {
    Sidebar,
    Notifications
  },
  methods: {
    ...mapActions(['loginUser']),
    fetchData(customerID) {
      api.loadConfiguration(customerID).then((data) => {
        console.log("configuration for %s loaded %v", customerID, data)
        this.$store.state.configuration = data
      }).catch((error) => {
        console.log("failed to load configuration for %s: %v", customerID, error)
      })
    },
    tryLoginUser() {
      const that = this
      if (this.user.email !== '') {
        this.loginUser({email: this.user.email, password: this.user.password}).then(() => {
        }, () => {
          that.$router.push('login')
        });
      } else {
        this.$router.push('login')
      }
    }
  }
};
</script>
<style lang="scss">
@import "assets/styles/main.scss";
</style>
